import type { FC } from 'react';

import { useInsightsTracking } from '@xing-com/crate-insights-tracking';
import { CarouselSection } from '@xing-com/crate-x4e-carousel-section';
import { ContentCard } from '@xing-com/crate-x4e-content-card';

import type { InsightsArticleFragment } from '../../graphql/insights-article.fragment.gql-types';

export const SalaryCarouselSection: FC<{
  articles?: InsightsArticleFragment[];
}> = ({ articles }) => {
  const { trackWithNWT } = useInsightsTracking();

  const filteredArticles = articles?.filter((article) => {
    const { details } = article;
    return Boolean(details?.title) || Boolean(details?.image);
  });

  return (filteredArticles?.length ?? 0) > 0 ? (
    <CarouselSection
      titleKey="INSIGHTS_LO_SALARY_SECTION_TITLE"
      subtitleKey="INSIGHTS_LO_SALARY_SECTION_SUBTITLE"
    >
      {filteredArticles?.map((props, index) => {
        const { objectUrn, category, details } = props ?? {};
        const { url } = details ?? {};
        const trackedUrl = `${url}?sc_o=insights_salary_articles_module_${category?.toLowerCase()}_click&sc_o_PropActionOrigin=discover_update_InsightsSalaryArticlesModule`;

        const trackArticle = (e?: MouseEvent): void =>
          trackWithNWT({
            event: e ? 'opened' : 'entered_viewport',
            element: 'salary_article',
            element_detail: category?.toLowerCase(),
            itemUrn: objectUrn ?? '',
            moduleTitle: 'discover_insights_salary_articles',
            position: index + 6,
            verticalPosition: 2,
            modulePosition: 2,
            positionInModule: index + 1,
          });

        return (
          <ContentCard
            key={objectUrn}
            to={trackedUrl}
            // @ts-expect-error FIXME: SC6
            onClick={trackArticle}
            onEnter={trackArticle}
            {...props}
            {...details}
          />
        );
      })}
    </CarouselSection>
  ) : null;
};
